import React, { Component } from "react";
import {primaryColor, webFont} from "../../config/theme";
import IconButton from "@material-ui/core/IconButton/IconButton";
import { AddCircle, RemoveCircle } from "@material-ui/icons";
import {Grid, Hidden} from "@material-ui/core";
import Input from '@material-ui/core/Input';
import Fab from "@material-ui/core/Fab/Fab";
import {NotificationManager} from "react-notifications";
import {compose, graphql} from "react-apollo";
import {UPDATE} from "../../graphql/mutations/user";
import UPDATE_CHEF from "../../graphql/mutations/chef/update_chef";
import {connect} from "react-redux";

class MyKitchen extends Component {
    constructor(props) {
        super(props);

        const {diner}=this.props;
        let equipments = diner ? diner.equipments :[];

        this.state={
          equipments: equipments,
            "equipment":"",
            "clickEquipment":false
        };
    }

    addEquipment = () => {
        const {equipment} = this.state;
        const {diner:{equipments}}=this.props
        if (equipment =='' || equipment==null) {
            return;
        }
        if (equipments.find(c => c === equipment)) {
            NotificationManager.error(equipment + " is already added", "Equipment");
            return;
        }

        equipments.push(equipment);
        this.setState({ equipments, equipment: "",clickEquipment:true });
    };

    removeEquipment =(equipment) =>{
        const {diner:{equipments}}=this.props
        let equip=equipment;
        let filterd = equipments.filter((value, index, arr) => {
            return value !== equip;
        });
        let index=equipments.indexOf(equipment);
        equipments.splice(index, 1);
        this.setState({ equipments: filterd, equipment: "" });
    }

    handleChange = (e)=>{
        let data =e.target.value;
        this.setState({
            equipment: data
        })
    }


    submitDetail = (event) => {
        event.preventDefault();
        const {equipments} = this.state;
        const {updateUser}=this.props;

        let formData = event.target.elements;
            let payload = {
                id: this.props.userId,
                equipments: equipments
            };

            updateUser({
                variables: {user: payload}
            }).then((res) => {
                NotificationManager.info("Equipments saved");

            }).catch(err => {
                console.log(JSON.parse(JSON.stringify(err)))
            })


    }

    render() {
        const {diner}=this.props;
        let equipments = diner ? diner.equipments :[];
        return (
            <div>
                <p style={styles.headerText}>My kitchen</p>
                <p style={styles.subHeaderText}>Let the chef know what equipment you have.</p>
                <form onSubmit={this.submitDetail}>
                    <Grid container spacing={16}>
                        <div className="short-container">
                            <Grid item xs={12}>
                                {equipments.map((equipment) => (<Grid container>
                                    <Grid item md={12} xs={12} sm={12} style={styles.inputButtonContainer}>
                                    <div style={{width: '100%'}}>
                                        <p style={styles.inputText}
                                        > {equipment.toUpperCase()} </p>

                                </div>
                                <div >
                                    <IconButton data-test-id={"remitem"} onClick={() => this.removeEquipment(equipment)} style={styles.removeCol}>
                                        <RemoveCircle color="primary" />
                                    </IconButton>
                                </div>
                                    </Grid>
                                </Grid>))}

                            </Grid>


                            <Grid item xs={12}>
                                    <Grid item md={12} xs={12} sm={12} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '8px 0'}}>
                                        <div >
                                            <Input
                                                name={"equipment"}
                                                placeholder={"Add Equipment"}
                                                type={"text"}
                                                style={styles.inputText}
                                                value={this.state.equipment}
                                                onChange= {(e)=>{this.handleChange(e)}}
                                            />

                                        </div>
                                        <div >
                                            <IconButton
                                                data-test-id={"additem"}
                                                style={{padding: 6, position: 'relative', left: '-28px',}}
                                                disabled={this.state.equipment.length <= 0}
                                                onClick={(e) => this.addEquipment()}
                                            >
                                                <AddCircle color={this.state.equipment.length <= 0 ? "grey" : "primary"} style={{fontSize: 24}} />
                                            </IconButton>
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>
                        <Grid
                            container
                            direction="row"
                            className="save-ipad"
                        >
                            <Grid item sm={12} md={12} style={{ textAlign: 'right', marginTop: 50, maxWidth: 310, width: '100%' }}>
                                <Fab
                                data-test-id={"kitchensub"}

                                    variant={"extended"}
                                    type="submit"
                                    style={styles.submitButton}
                                >
                                    Save
                                </Fab>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </div>
        );
    }
}

const mapSateToProps = state => {
    return {
        userId: state.auth.userId,
        isChef: state.auth.isChef,
        diner:  state.user.diner,
        chef: state.user.chef
    };
};
const MyKitchenWithData = compose(
    graphql(UPDATE, { name: "updateUser" }),
    graphql(UPDATE_CHEF, { name: "updateChef" })

)(MyKitchen);
const UserUpdateMyKitchen = connect(mapSateToProps)(MyKitchenWithData);


export default UserUpdateMyKitchen;
const styles={
    headerText: {
        fontSize: 30,
        textAlign: "left",
        margin: 0,
        paddingBottom: 10,
        fontFamily: webFont,
        fontWeight: 500,
    },
    subHeaderText: {
        fontSize: 15,
        textAlign: "left",
        margin: 0,
        paddingBottom: 30,
        fontFamily: webFont,
        fontWeight: 'normal'
    },
    inputButtonContainer: {
        display: "flex",
        justifyContent:"space-between",
        alignItems: 'center'
    },
    inputText: {
        fontFamily: webFont,
        fontSize:"18px",
        width: "100%",
        height: "62%",
    },
    submitButton: {
        borderRadius: 25,
        backgroundColor: primaryColor,
        border: "none",
        minWidth: 200,
        color: "white",
        height: 49,
        fontFamily: webFont,
        textTransform: "none",
        fontWeight: "normal",
        boxShadow: 'none',
        fontSize: 18
    },
    removeCol: {
        position: 'relative',
        left: '-32px',
        padding: 6,
    }
}
